import { configureStore } from "@reduxjs/toolkit";
import { profileReducer, subscriptionReducer, userReducer } from "./reducers/userReducer";
import { courseReducer } from "./reducers/courseReducer";
import { adminReducer } from "./reducers/adminReducer";

const store = configureStore({
  reducer: {
    user: userReducer,
    courses : courseReducer,
    profile : profileReducer,
    subscription : subscriptionReducer,
    admin : adminReducer
  },
});

export default store;

//server link
// export const server_endpoint = "http://localhost:4000/v1/api";
export const server_endpoint = "https://saas-server-sfnr.onrender.com/v1/api";




